module.exports = __webpack_public_path__ + "img/wilki_3.30cfb50a.jpg";